import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Repo from "../views/Repo.vue";
import OrgSignup from "../views/OrgSignup.vue";
import Error from "../views/Error.vue";
import Org from "../views/Org.vue";
import Login from "../views/Login.vue";
import { parseAuthTokens } from "../common/authentication_utils";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/org/:orgid/repo/:repoid",
    name: "Repo",
    component: Repo,
  },
  {
    path: "/org/:orgid",
    name: "Org",
    component: Org,
  },
  {
    path: "/add",
    name: "OrgSignup",
    component: OrgSignup,
    meta: {requiresGroup:    process.env.VUE_APP_ADMIN_GROUP} // use env variable
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "*",
    name: "not-found",
    component: Error,
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const accessToken = localStorage.getItem("accessToken");
  const idToken = localStorage.getItem("idToken");
  const { decodedAccessToken, } = parseAuthTokens(accessToken, idToken); 

  if (to.name !== "Login" && !(accessToken || idToken)) {
    next({ name: "Login" });
  } else if ((to.meta.requiresGroup
                 && !decodedAccessToken['cognito:groups'].includes(to.meta.requiresGroup))
            ) {
    window.location.href = "https://http.cat/403"; // send them to cat jail
  } else {
    next();
  }
});

export default router;
